export default __webpack_public_path__ + "static/media/order.b7f7c1e0.png";